var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80261 12.2526C8.42708 12.6759 9.18815 12.9319 9.99802 12.9319C12.1446 12.9319 13.8912 11.1696 13.8912 9.00369C13.8912 8.18655 13.6375 7.41863 13.218 6.78855L12.1544 7.86166C12.33 8.1964 12.4276 8.5902 12.4276 9.00369C12.4276 10.3525 11.3348 11.4551 9.99802 11.4551C9.58821 11.4551 9.19791 11.3567 8.86616 11.1795L7.80261 12.2526ZM16.4281 3.54952C17.843 4.84907 19.0431 6.60149 19.9408 8.70834C20.0188 8.8954 20.0188 9.11199 19.9408 9.2892C17.8527 14.1921 14.1351 17.1259 9.99802 17.1259H9.98826C8.10509 17.1259 6.29997 16.5056 4.70952 15.3735L2.81658 17.2834C2.67022 17.4311 2.48483 17.5 2.29944 17.5C2.11405 17.5 1.9189 17.4311 1.7823 17.2834C1.53837 17.0373 1.49934 16.6435 1.69448 16.358L1.72376 16.3186L16.1549 1.75771C16.1744 1.73802 16.194 1.71833 16.2037 1.69864L16.2037 1.69863C16.2232 1.67894 16.2427 1.65925 16.2525 1.63957L17.1697 0.714131C17.4624 0.428623 17.921 0.428623 18.204 0.714131C18.4967 0.999638 18.4967 1.4722 18.204 1.75771L16.4281 3.54952ZM6.09836 9.00753C6.09836 9.2635 6.12764 9.51948 6.16667 9.75576L2.55643 13.3984C1.5807 12.2564 0.731804 10.8781 0.0585443 9.29304C-0.0195148 9.11583 -0.0195148 8.89924 0.0585443 8.71218C2.14662 3.80933 5.86419 0.885337 9.99156 0.885337H10.0013C11.3966 0.885337 12.7529 1.22007 14.0018 1.85015L10.7429 5.13841C10.5087 5.09903 10.255 5.0695 10.0013 5.0695C7.84494 5.0695 6.09836 6.83177 6.09836 9.00753Z",
    fill: "#8A7C8D",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.990f537d8b4ebd8885ed25008d13c35d.svg";
export { ForwardRef as ReactComponent };